import Swiper from 'swiper';

class ProduitAssociesSlider {

  constructor(){
    this.component = document.querySelector('[data-component="produit-slider"]');
    this.trigger = document.querySelector('[data-trigger="produit-slider"]');
    this._init();
  }
  
  _init(){
    
    if( this.component ){
      let swiper = null;
      
      
      // If swiper is init before image is loaded, we reload swiper
      // (when lazyload images with data-visibility)
      const firstImage = this.trigger.querySelector('img');
      if(firstImage){
        firstImage.onload = ()=> {
          if(swiper){
            swiper.update();
          }
        };
      }
            
      swiper = new Swiper(this.trigger, {
        slidesPerView: 4,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        watchOverflow:true,
        preloadImages: false,
        lazy: {
          loadOnTransitionStart: true,
        },
        breakpoints: {
          440: {
            slidesPerView: 2,
            slidesPerColumn: 2
          },
          640: {
            slidesPerView: 2,
          }
        }
      });

    }
  }

}

export const produitAssociesSlider = new ProduitAssociesSlider();